export function luxotticaSecondPairEligible(hit, colorIndex, promotion, now = Date.now()) {
    if (!(promotion?.enabled ?? promotion?.active)) return false;
    const prefix = 'luxottica_second_pair_';
    const value = field => colorIndex > 0
        ? hit?.other?.[prefix + field]?.[colorIndex - 1]
        : hit?.[prefix + field];
    const start = Number(value('starts_at'));
    const end = Number(value('ends_at'));
    const couponStart = Number(promotion.starts_at);
    const couponEnd = Number(promotion.ends_at);
    const seconds = now / 1000;
    return value('participating') === true
        && Number.isFinite(start) && Number.isFinite(end)
        && end > start && seconds >= start && seconds < end
        && couponEnd > couponStart && seconds >= couponStart && seconds < couponEnd;
}
